// extracted by mini-css-extract-plugin
export default {"base":"CountryFlag_base__cjy+y"};